<template>
  <div class="index">

    <!-- 轮播图 -->
    <div class="top">
      <el-carousel ref="carousel">
           <!-- <el-carousel-item>
          <div class="banner">
            <div class="imgBg">  <a href="newsDetail?id=54&source=indexCalendar" target="_blank"> <img src="@/assets/img/bannerBhbia.jpg"></a></div>
          </div>
        </el-carousel-item> -->
         <!-- <el-carousel-item >
          <div class="banner" >
            <div class="imgBg d-none d-sm-block"><img src="@/assets/img/Banner_Intellus_White.png"></div>
            <div class="imgBg d-block d-sm-none"><img src="@/assets/img/Banner_Intellus_WhiteMobile.png"></div>

            <div class="value value_intell" @click="$router.push('/newsDetail?id=52&source=homepage')">Visit Us Here</div>
      
          </div>
        </el-carousel-item> -->
        <el-carousel-item>
          <div class="banner">
            <div class="imgBg eada_imgBg"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/banner_eada.jpg"></div>
            <div class="value value_eada">
              <div class="eada_logo"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/eQuote2.png" alt=""></div>
              <div>Instant Quotation System</div>
              <div style="" class="quotevalue">Asia Quotation Only a Click Away</div>
              <div><button class="banner_button" @click="$router.push('/equote?source=homepage')">Find out more</button></div>
            </div>

          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner">
            <div class="imgBg"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/banner_appa.jpg"></div>
            <div class="value value_appa">
              Welcome to the Asia Physician Panel Alliance
              <button class="pc d-none d-sm-block"><a href="https://www.appa360.com/?source=appa_holdendata" target="_blank"> Read more</a></button>
            </div>

            <div class="value readmore"> <button class="mobile d-block d-sm-none"><a href="https://www.appa360.com/?source=appa_holdendata" target="_blank"> Read more</a></button></div>

            <div class="appa_logo"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/appa/APPA.png" alt=""></div>

          </div>
        </el-carousel-item>

        <el-carousel-item>
          <div class="banner">
            <div class="imgBg"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/banner1.jpg"></div>
            <div class="value">
              <div> We Are Your Research Team on the Ground in Asia</div>
              <button class="mobile d-block d-sm-none" @click="$router.push('/aboutUs?source=homepage')">Read more</button>
            </div>

          </div>
        </el-carousel-item>
        <el-carousel-item>
          <div class="banner">
            <div class="imgBg"><img src="@/assets/img/banner_quirksBG.jpg"></div>
            <div class="quirks_left">
              <div><img src="@/assets/img/banner_quirks1.png"></div>
            </div>
            <div class="quirks_right">
              <div><img src="@/assets/img/banner_quirks2.png"></div>
              <div><button class="quirks_button"><a href="https://bluetoad.com/publication/?i=812227&p=38&view=issueViewer" target="_blank"> Read more</a></button></div>

            </div>

          </div>
        </el-carousel-item>
       

      </el-carousel>
    </div>

    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Latest Events
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
      <div class="value">
      </div>
    </div>
    <!-- 日历 -->
    <div class="calendar">

      <Carrousel></Carrousel>
      <Carrouselmobile></Carrouselmobile>
    </div>

    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Holden Services
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
      <div class="value">
        We offer a wide-range of research services from research design to field operations to research consulting.
      </div>
    </div>

    <!-- 第一部分介绍公司 -->
    <div class="message">
      <div class="box" @click="$router.push('/qual?source=index')">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconHealthcare.png">
        </div>
        <div class="value">
          Qualitative
        </div>
      </div>
      <div class="box" @click="$router.push('/quant?source=index')">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconMedtech.png">
        </div>
        <div class="value">
          Quantitative
        </div>
      </div>
      <div class="box" @click="$router.push('/industry?source=index')">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconConsumer.png">
        </div>
        <div class="value">
          Industry Expertise
        </div>
      </div>
      <div class="box" @click="$router.push('/specialist?source=index')">
        <div class="img">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/iconAsia.png">
        </div>
        <div class="value">
          Specialist Solutions
        </div>
      </div>
    </div>

    <!-- 分割区域条 -->
    <!-- <div class="titleLine">
      <div class="title">
        We get things done in Speed<sup>+</sup>
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png" alt="">
      <div class="value">
        Speed is the key to success，but so are the others
      </div>
    </div> -->

    <!-- We get things Done -->
    <!-- <div class="things">
      <div class="left">
        <div>Speed + Asia Access</div>
        <div>Speed + Quality</div>
      </div>
      <div class="d-none d-md-block img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/speed.jpg"></div>
      <div class="right">
        <div>Speed + All Methods</div>
        <div>Speed + Insight</div>
      </div>

    </div> -->
    <!-- 分割区域条 -->
    <!-- <div class="titleLine">
      <div class="title">
        Our HCP Advisors
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
    </div> -->

    <!-- 请来培训的医生介绍 -->
    <!-- <div class="doctors">
      <div class="three">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/doctorShu.jpg">
        <div class="doctorName">
          Dr. Zhiqiang Shu
        </div>
        <div class="doctorValue">
          Chief Physician
        </div>
        <div class="doctorValue">
          Neurological Surgery
        </div>
      </div>

      <div class="three">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/doctorRui.jpg">
        <div class="doctorName">
          Dr. Rui Liu
        </div>
        <div class="doctorValue">
          Associate Chief Physician
        </div>
        <div class="doctorValue">
          Cardial & Thoracic Surgery
        </div>
      </div>

      <div class="three">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/doctorNing.jpg">
        <div class="doctorName">
          Dr. Ning Liu
        </div>
        <div class="doctorValue">
          Associate Chief Physician
        </div>
        <div class="doctorValue">
          Neurology
        </div>
      </div>

      <div class="three">
        <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/doctorChen.jpg">
        <div class="doctorName">
          Dr. Ye Chen
        </div>
        <div class="doctorValue">
          Attending Physician
        </div>
        <div class="doctorValue">
          Oncology
        </div>
      </div>
    </div> -->

    <!-- 分割区域条 -->
    <div class="titleLine Experience">
      <div class="title">
        Why Holden
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
      <div class="value">
        <!-- We have conducted over 2000 projects, both quantitative & qualitative in past 3 years -->
      </div>
    </div>
    <!-- whyholden  -->
    <div class="experience">
      <div class="data">
        <div class="box">
          <div class="num">
            All
          </div>
          <div class="detatil">
            Covering all Asian markets
          </div>

        </div>
        <div class="box">
          <div class="num">
            Millions
          </div>
          <div class="detatil">
            Doctors & patient resources
          </div>

        </div>
        <div class="box">
          <div class="num">
            500+
          </div>
          <div class="detatil">
            Projects in 2023
          </div>

        </div>
        <div class="box">
          <div class="num">
            30000+
          </div>
          <div class="detatil">
            Complete samples in 2023
          </div>

        </div>
        <div class="box">
          <div class="num">
            4.8
          </div>
          <div class="detatil">
            Customer NPS
          </div>

        </div>
      </div>
      <asia-map />
    </div>
    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Holden Products
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
      <div class="value">
      </div>
    </div>
    <!-- 浩顿产品 -->
    <div class="products">
      <div class="menu">
        <div class="icon equote" style="cursor:pointer" @click="toPath('/equote?source=products')">
          <i class="el-icon-s-opportunity"></i>
          <div>eQuote</div>
        </div>
        <div class="icon" @mouseover="products=2" :class="{bg:products==2}">
          <i class="el-icon-question"></i>
          <div>Holden Answer</div>
        </div>
        <div class="icon" @mouseover="products=3" :class="{bg:products==3}">
          <i class="el-icon-s-promotion"></i>
          <div>API</div>
        </div>

        <div class="icon" @mouseover="products=5" :class="{bg:products==5}">
          <i class="el-icon-s-order"></i>
          <div>Survey Panda</div>
        </div>
      </div>
      <div class="productsValue">
        <div v-if="products==1" class="one">1</div>
        <div v-if="products==2" class="two">
          <div class="title">
            Innovate, Interact, Insight: </br>AME - Your Gateway to Smart Healthcare Research
          </div>
          <div class="holdenanswer">
            <div class="holderanswerimg d-block d-sm-none"><img src="@/assets/img/holdenanswer.png" alt=""></div>
            <div class="value">
              <div style="display:flex;margin-bottom:20px">
                <!-- <div>1.</div> -->
                <div><span style="color:#2cb1e9;font-weight:700">Holden Answer</span> is an interactive, Al-enabled interface for market researchers in the healthcare industry.</div>

              </div>
              <div style="display:flex;margin-bottom:20px">
                <!-- <div>2.</div> -->
                <div>In additional to web trawling functions, and its advanced language model, Holden has built upon it to with its database of both primary and secondary research data to provide both researchers up-to-date and useful market information.</div>
              </div>
              <div style="display:flex;margin-bottom:20px">
                <!-- <div>3.</div> -->
                <div>Friends and clients of Holden can take advantage of non-sensitive primary and secondary research data to supplement their research or simply get to know more about their target markets.</div>
              </div>
              <div style="display:flex;margin-bottom:20px">
                <!-- <div>4.</div> -->
                <div>Whether you need help with healthcare, research, want to brainstorm ideas, or simply engage in a friendly conversation, <span style="color:#2cb1e9;font-weight:700">Holden Answer</span> is here to provide you with intelligent and interactive assistance.</div>
              </div>
              <!-- <div style="display:flex">
              <div>5.</div>
              <div>Whether you need help with healthcare, research, want to brainstorm ideas, or simply engage in a friendly conversation, Holden Knowledge Platform is here to provide you with intelligent and interactive assistance.</div>
            </div> -->
              <div class="button">
                <el-button type="primary" @click="toPath('/contact?source=products')">Request a demo</el-button>
                <el-button type="primary"><a href="https://www.asiamedeyes.com/#/login" target="_blank">Try it!</a></el-button>
              </div>
            </div>
            <div class="holderanswerimg d-none d-sm-block"><img src="@/assets/img/holdenanswer.png" alt=""></div>
          </div>
        </div>
        <div v-if="products==3" class="three">
          <div class="title">
            API
          </div>
          <div class="apiimg">
            <div class="holderanswerimg d-block d-sm-none"><img src="@/assets/img/api.png" alt=""></div>
            <div class="value">
              <div style="display:flex;margin-bottom:20px">
                <!-- <div>1.</div> -->
                <div>Unlock the full potential of our proprietary products by seamlessly integrating with our custom-developed API. Empower partners to harness the capabilities of our cutting-edge solutions and enhance their applications with ease.</div>
              </div>
              <div style="display:flex" class="api">
                <div class="apileft">● Seamless Integration:</div>
                <div class="apiright"> Our API is designed for effortless integration, ensuring a smooth and efficient collaboration between our products and your applications.</div>
              </div>
              <div style="display:flex" class="api">
                <div class="apileft">● Customization:</div>
                <div class="apiright"> Tailor our solutions to meet your specific needs. Our API allows for flexible customization, enabling partners to adapt and optimize functionality according to their unique requirements.</div>
              </div>
              <div style="display:flex" class="api">
                <div class="apileft">● Efficiency and Productivity:</div>
                <div class="apiright"> Streamline workflows and boost productivity with the seamless connectivity facilitated by our API, allowing for quick data exchange and real-time updates.</div>
              </div>
              <div style="display:flex">
                <!-- <div>5.</div> -->
                <div>Partner with us to take advantage of these benefits and elevate your applications to new heights with our powerful API integration.</div>
              </div>
              <div class="button">
                <el-button type="primary" @click="toPath('/contact?source=products')">Contact us</el-button>

              </div>

            </div>
            <div class="holderanswerimg d-none d-sm-block"><img src="@/assets/img/api.png" alt=""></div>
          </div>
        </div>

        <div v-if="products==5" class="five">
          <!-- SurveyPanda -->
          <div class="SurveyPanda" id="SurveyPanda">

            <div class="text">
              <div class="title">
                SurveyPanda
              </div>
              <div class="value">
                Is our self-developed online data collection platform and reporting system. SurveyPanda is user friendly and allows for DIY research solutions. At the same time, it is designed to cater for complicated market research requirement.

              </div>
            </div>
            <div class="img"><img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/programming/surveyPanda.jpg" alt="">
              <div class="color"></div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <!-- Our Clients Say -->
    <div class="Clients">
      <div class="text">
        <div class="title">
          What our clients say
        </div>
        <div class="value">
          <el-carousel ref="carousel" indicator-position="none">
            <el-carousel-item v-for="(item,index2) in clients" :key="index2">
              <div class="says">{{item.value}}</div>
            </el-carousel-item>

          </el-carousel>

        </div>
      </div>

    </div>
    <!-- 公司的成就 -->
    <!-- <div class="experience">
      <div class="box">
        <div class="num">860</div>
        <div>--</div>
        <div class="text">HC & MedTech</div>
      </div>
      <div class="box">
        <div class="num">1116</div>
        <div>--</div>
        <div class="text">Consumer</div>
      </div>
      <div class="box">
        <div class="num">1664</div>
        <div>--</div>
        <div class="text">Greater China</div>
      </div>
      <div class="box">
        <div class="num">281</div>
        <div>--</div>
        <div class="text">Other Asian Markets</div>
      </div>
    </div> -->

    <!-- 分割区域条 -->
    <!-- <div class="titleLine">
      <divclass="title">
        Our Solutions
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
      <div class="value">
        Our team is happy to discuss about your research needs and provides our best recommendations on research solutions
      </div>
    </div> -->

    <!-- Our Solutions -->
    <!-- <div class="solutions">
      左边图片
      <div class="value">
        <div class=" d-none d-sm-block solutionsImg">
          <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/index/solutions.jpg">
        </div>
        右边文字
        <div>

        </div>
        <div class="solutionsValue">
          <div class="solutionstext">We have conducted over 2000 projects in the past 3 years.</div>

          <div class="oneBox solutionbox">
            <i class="el-icon-s-order " />
            <div class="text">
              <span>Qualitative Projects</span>
              <div>321</div>
            </div>
          </div>
          <div class="twoBox solutionbox">
            <i class="el-icon-s-data" />
            <div class="text">
              <span>Quantitative Projects</span>
              <div>1695</div>
            </div>
          </div>
          <div class="threeBox solutionbox">
            <i class="el-icon-s-claim " />
            <div class="text">
              <span>Research & Analytics Projects</span>
              <div>884</div>
            </div>
          </div>
          <div class="fourBox solutionbox">
            <i class="el-icon-s-management" />
            <div class="text">
              <span>AI Assisted Transcription</br> & Summary</span>
              <div>1096</div>
            </div>
          </div>
        </div>
      </div>
      <div class="annotation" style="float:right;color:#7e6a6c">* Based on project data as of December 31,2022</div>
    </div> -->

    <!-- 分割区域条 -->
    <div class="titleLine">
      <div class="title">
        Latest News & Release
      </div>
      <img src="https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/title-hline.png">
    </div>

    <!-- case study -->
    <!-- <div class="news">
      <div @click="btn('/media')" class="more">read more</div>

      <div class="newsList">

        <div class="one" v-for="(item,index) in caseList.slice(0,4)" :key="index" @click="toDetailcase(item.id)">
          <img :src="item.logo">
          <div class="title">
            {{item.customerTitle}}
          </div>
        </div>

      </div>
    </div> -->
    <!-- news -->
    <div class="news">
      <!-- <div @click="btn('/media?source=index')" class="more">read more</div> -->
      <div class="newsList">
        <div class="topnews">

          <div class="topNews" v-for="(item,index) in topNews.slice(0,1)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
                  <!-- .split(",") -->
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>
            <div class="newsDesc overflowMulityText3">
              {{ item.newsDesc }}
            </div>

          </div>
          <div @click="btn('/media?source=index')" class="more">read more</div>
        </div>
        <div class="notopnews">

          <div class="one" v-for="(item,index) in newsList.slice(0,3)" :key="index" @click="toDetail(item.id,item.subscribe,item.newsTitle)">
            <img :src="item.logo">
            <div>
              <div>
                <div class="label">
                  {{item.firstLabel}}
                </div>
                <div class="label" v-for="label in item.othersLabel.split(',').slice(0,3)">
                  {{label}}
                  <!-- .split(",") -->
                </div>
              </div>

              <div class="title">
                {{ item.newsTitle }}
              </div>
            </div>

          </div>
        </div>

      </div>
    </div>
    <el-dialog title="" :visible="DialogShow" width="45%" @close="DialogShow=false">
      <span>
        <div class="from">
          <div class="formtitle">Please fill in your information</div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item label="First Name" prop="firstname">
              <el-input v-model="ruleForm.firstname" />
            </el-form-item>
            <el-form-item label="Last Name" prop="lastname">
              <el-input v-model="ruleForm.lastname" />
            </el-form-item>
            <el-form-item label="Email" prop="mail">
              <el-input v-model="ruleForm.mail" />
            </el-form-item>
            <el-form-item label="Company" prop="company">
              <el-input v-model="ruleForm.company" />
            </el-form-item>
            <el-form-item prop="check" style="width:100%">

              <input class="check" type="checkbox" v-model="ruleForm.check"><span style="word-break: break-word;">Yes, I would like to receive digital communications from Holden brands. I may opt-out of communications at any time using the unsubscribe link at the bottom of any email communication.</span>
            </el-form-item>
          </el-form>

        </div>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="DialogShow = false">cancel</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">submit</el-button>

      </span>
    </el-dialog>
  </div>
</template>

<script>
// import '@/config/rem'

const defaultForm = {
  action: "News",
  actionCase: "Readnews",
  targetName: "",
  mail: "",
  firstname: "",
  lastname: "",
  company: "",
  check: true
};
import vueSeamlessScroll from "vue-seamless-scroll";
import { getNewsList, getCustomerList, advertisementFlow, actionRecords } from "@/api/api";

import Carrousel from "@/components/swiper.vue";
import Carrouselmobile from "@/components/swiperMobile.vue";
import AsiaMap from "@/components/asiaMap";

export default {
  name: "Index",
  data() {
    const check = (rule, value, callback) => {
      if (value == false) {
        return callback(new Error("Please complete this required field"));
      } else {
        callback();
      }
    };
    return {
      // // notNextTick是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
      // notNextTick: true,
      // swiperOption: {
      //   // swiper options 所有的配置同swiper官方api配置
      //   autoplay: false, // 自动播放的时间间隔
      //   slidesPerView: 4, //一次显示的数量
      //   direction: "horizontal", // 水平轮播
      //   grabCursor: true,
      //   setWrapperSize: true,
      //   loop: true, //  循环播放
      //   autoHeight: true,
      //   // pagination: ".swiper-pagination",
      //   paginationClickable: true,
      //   prevButton: ".swiper-button-prev",
      //   nextButton: ".swiper-button-next",
      //   // scrollbar: ".swiper-scrollbar",
      //   mousewheelControl: true,
      //   observeParents: true,
      //   // 如果自行设计了插件，那么插件的一些配置相关参数，也应该出现在这个对象中，如下debugger
      //   debugger: true,
      //   // swiper callbacks
      //   // swiper的各种回调函数也可以出现在这个对象中，和swiper官方一样
      //   onTransitionStart(swiper) {
      //     console.log(swiper);
      //   }
      //   // more Swiper configs and callbacks...
      //   // ...
      // },
      // classOption: {
      //   limitMoveNum: 2,
      //   switchSingleStep: 140,
      //   direction: 3
      // },
      ruleForm: JSON.parse(JSON.stringify(defaultForm)),
      rules: {
        firstname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        lastname: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        company: [{ required: true, message: "Please complete this required field", trigger: "blur" }],
        mail: [
          { required: true, message: "Please complete this required field", trigger: "blur" },
          { type: "email", message: "Email must be formatted correctly.", trigger: ["blur"] }
        ]
        // check: [{ required: true, message: "Please complete this required field", trigger: "blur" }, { validator: check }]
      },
      DialogShow: false,
      caseList: [],
      slide: 0,
      sliding: null,
      newsList: [],
      isShow: 0,
      topNews: [],
      products: 2,
      clients: [
        { value: "“ Great work helping us close so fast! ”" },
        { value: "“ As always, the Holden team consistently responds to proposal requests in a clear, concise, and quick way, and it is always a pleasure to work with the team. ”" },
        { value: "“ Thank you for making my experience, as well as my clients experience a great one! We will definitely be looking forward to working with the team again in the near future :) ”" },
        { value: "“ Your team always does a wonderful job and it's always a pleasure working with you all. I know my projects will be in good hands which takes off the pressure from my end. Thank you and keep doing what you do ”" },
        { value: "“ Holden did a great job setting expectations on what can be realistically delivered per week - this helped greatly with client management on our end. Thank you! ”" },
        { value: "“ Fabulous recruit in India despite the global pandemic difficulties! ”" },
        { value: "“ I would definitely work with you again, very well done! ”" },
        { value: "“ Great communication and delivered earlier than what we expected  Thank you :) ”" },
        { value: "“ Team was awesome and responsive. Fielding went as promised. Please keep it up. ”" },
        { value: "“ Great team to work with!!!Nicole and the Taiwan team were responsive and great to work with.Nicole and her Team are always efficient with various back matching and recontact queries. It make fielding much easier! Thanks Nicole and Team :D ”" },
        { value: "“ Jenny was great and helped handle fieldwork despite some difficult sub quota difficulties! ”" },
        { value: "“ You are doing a great job and the team makes things easier for everyone which is very much appreciated and it is exactly what we expect from a panel partner ”" },
        { value: "“ As working with Nicole has been such a pleasure. She is friendly, efficient and always reliable. Thank you for all your hard work in 2021. We hope to be able to continue working with Nicole and Holden for a successful 2022 ”" }
      ]
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  created() {
    this.loading();
    this.getNewsList();
    this.getCustomerList();
    this.advertisementFlow(); // 在组件创建时加载Google代码
    const script = document.createElement("script");
    script.async = true;
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-11335422054";
    document.head.appendChild(script);
    script.onload = () => {
      window.dataLayer = window.dataLayer || [];
      function gtag() {
        dataLayer.push(arguments);
      }
      gtag("js", new Date());
      gtag("config", "AW-11335422054");
    };
    window.addEventListener("load", function() {
      if (window.location.href.includes("https://www.holdendata.com/")) {
        gtag("event", "conversion", { send_to: "AW-11335422054/ry3sCOGp7fYYEOagk50q" });
      }
    });
    this.webinercookies();
    //  this.getNewsList(2);
    // 在组件创建时加载Google代码
  },
  mounted() {
    //调用方法
    this.slideBanner();
  },
  components: {
    vueSeamlessScroll,
    Carrousel,
    Carrouselmobile,
    AsiaMap
  },
  methods: {
    toPath(path) {
      this.$router.push({
        path
      });
    },
    webinercookies() {
      // 如果没有记录cookie
      if (!localStorage.getItem("webinersource")) {
        // 就不重新赋值
        let webinersource = this.$route.query.source;

        if (webinersource == undefined) {
          localStorage.setItem("webinersource", "www");
        } else {
          localStorage.setItem("webinersource", webinersource);
        }
        // console.log(1);
      } else {
        // 如果没有cookie就设置cookie
      }
    },
    submitForm(formName) {
      let _this = this;
      // 数据写入表单
      _this.$refs[formName].validate(valid => {
        if (valid) {
          _this.ruleForm.fullName = _this.ruleForm.firstname + " " + _this.ruleForm.lastname;
          let ruleForm = {
            action: "News",
            actionCase: "Readnews",
            firstName: _this.ruleForm.firstname,
            fullName: _this.ruleForm.fullName,
            mail: _this.ruleForm.mail,
            company: _this.ruleForm.company
          };
          //   console.log(this.ruleForm);
          localStorage.setItem("form", JSON.stringify(this.ruleForm));
          var form = JSON.parse(localStorage.getItem("form"));
          form.targetName = this.submitTitle;
          console.log(form);
          // 提交表单数据
          actionRecords(form).then(res => {
            // console.log(form);
            // 如果没有cookie
            // 提交成功
            if (res.code == 10000) {
              // 关闭弹框
              this.DialogShow = false;
              // 如果是同意或者没点，存入cookie
              if (localStorage.getItem("agreeCookies")) {
                var val = localStorage.getItem("agreeCookies");
                var dataobj = JSON.parse(val);
                if (dataobj.val == "agree") {
                  this.$cookies.set("HoldenCookies", "panelDownloads");
                }
              } else if (this.$cookies.isKey("defaultcookies")) {
                this.$cookies.set("HoldenCookies", "panelDownloads");
              }
              // 跳转查看详情
              this.$router.push({ name: "newsDetail", query: { id: this.submitId, source: "index" } });
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    /*轮播手滑切换*/
    startAuto() {
      if (this.autoplay == false) {
        this.autoplay = true;
      }
    },
    stopAuto() {
      if (this.autoplay == true) {
        this.autoplay = false;
      }
    },
    slideBanner() {
      let that = this;
      //选中item的盒子
      var box = document.querySelector(".el-carousel__container");
      //手指起点X坐标
      var startPoint = 0;
      //手指滑动重点X坐标
      var stopPoint = 0;

      //重置坐标
      var resetPoint = function() {
        startPoint = 0;
        stopPoint = 0;
      };

      //手指按下
      box.addEventListener("touchstart", function(e) {
        //手指按下的时候停止自动轮播
        that.stopAuto();
        //手指点击位置的X坐标
        startPoint = e.changedTouches[0].pageX;
      });
      //手指滑动
      box.addEventListener("touchmove", function(e) {
        //手指滑动后终点位置X的坐标
        stopPoint = e.changedTouches[0].pageX;
      });
      //当手指抬起的时候，判断图片滚动离左右的距离
      box.addEventListener("touchend", function(e) {
        console.log(e);
        console.log("1：" + startPoint);
        console.log("2：" + stopPoint);
        if (stopPoint == 0 || startPoint - stopPoint == 0) {
          resetPoint();
          return;
        }
        if (startPoint - stopPoint > 0) {
          resetPoint();
          that.$refs.carousel.next();
          return;
        }
        if (startPoint - stopPoint < 0) {
          resetPoint();
          that.$refs.carousel.prev();
          return;
        }
      });
    },
    loading() {
      this.$loading({
        lock: true,
        background: "rgba(255, 255, 255,1)"
      });
      setTimeout(() => {
        this.$loading().close();
      }, 700);
    },
    advertisementFlow() {
      // 如果没有source
      if (this.$route.query.source == undefined) {
        // console.log(1);
        // 就把source拼接
        advertisementFlow({
          path: "index",
          source: "",
          information: "首页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
        // 如果有source
      } else {
        advertisementFlow({
          path: "index",
          source: this.$route.query.source,
          information: "首页"
        }).then(res => {
          if (res.code == 10000) {
            // console.log(res);
          }
        });
      }
    },
    getCustomerList() {
      getCustomerList({
        pageSize: 4,
        pageIndex: 1,
        status: 1, //启用
        origin: 1, //前台
        isRecommend: 1, //是否推荐
        customerType: 1
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "查询案例分享失败");
          return;
        }
        this.caseList = res.datalist || [];
        this.allCount = res.allCount;
      });
    },
    btn(path) {
      this.$router.push({
        path
      });
    },
    show(num) {
      this.isShow = num;
    },
    toDetailcase(id) {
      this.$router.push({ name: "caseDetail", query: { id: id } });
    },
    toDetail(id, subscribe, newsTitle) {
      if (subscribe == 1 && !this.$cookies.isKey("HoldenCookies")) {
        this.submitId = id;
        this.DialogShow = true;
        this.submitTitle = newsTitle;
      }
      // 如果需要权限并且没有cookie
      else {
        this.$router.push({ name: "newsDetail", query: { id: id, source: "index" } });
      }
    },
    getNewsList() {
      getNewsList({
        pageSize: 0,
        pageIndex: 1,
        status: 1, //启用
        origin: 1 //前台
      }).then(res => {
        if (res.code != 10000) {
          this.$message.error(res.msg || "Failed to query news information");
          return;
        } else {
          this.newsList = res.datalist.filter(k => k.topFlag != 1);
          this.topNews = res.datalist.filter(k => k.topFlag == 1);
        }
      });
    }
    // eslint-disable-next-line no-unused-vars
    // format(percentage) {}
  }
};
</script>

<style lang="scss" scoped>
.calendar {
  background-color: #fff;
  padding: 0px 80px;
}

.quotevalue {
  font-size: 25px;
}
.top {
  /deep/.el-carousel {
    height: 590px;

    .el-carousel__container {
      height: 590px;
    }
  }
  .el-carousel__item h3 {
    color: #475669;
    font-size: 36px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #fff;
  }

  .el-carousel__item:nth-child(2n + 1) {
    background-color: #fff;
  }
}
.banner {
  width: 100%;
  height: 100%;
  // background-color: pink;
  position: relative;
  .pc {
    color: #fff;
    border: none;
    font-size: 30px;
    background-color: #2cb1e9;
    margin: 0 auto;
    margin-top: 20px;
  }
  img {
    width: 100%;
  }
  .value {
    position: absolute;
    top: 15%;
    right: 7%;
    width: 40%;
    text-align: center;
    font-size: 60px;
    font-weight: 700;
    color: #003c50;
    text-shadow: 1px 1px #000;
  }
  .value_appa {
    width: 100%;
    top: 25%;
    right: 0;
    background-color: rgba(255, 255, 255, 0.8);
    padding: 80px 0;
  }
  .appa_logo {
    position: absolute;
    width: 360px;
    height: 360px;
    // background-color:#2cb1e9;
    background: linear-gradient(#05466b, #68c5ec);
    right: -30px;
    top: -120px;
    border-radius: 50%;
    box-shadow: 1px 2px 20px #ccc;
    img {
      width: 250px;
      margin-top: 170px;
      margin-left: 40px;
    }
  }
  .value_eada {
    background-color: rgba(75, 67, 67, 0.5);
    width: 100%;
    height: 100%;
    left: 0px;
    padding-left: 100px;
    padding-top: 100px;
    color: #fff;
    // width: 50%;
    top: 0;
    text-align: left;
    font-size: 40px;
    .eada_logo {
      font-family: "Cooper Black";
      font-size: 100px;
      img {
        width: 350px;
      }
    }
    .banner_button {
      font-size: 25px;
      border: none;
      color: #fff;
      background-color: rgba(255, 255, 255, 0.5);
      padding: 10px;
      margin-top: 40px;
    }
  }
  .value_intell{
     color: #fff;
     font-size: 25px;
     left: 15%;
     top: 85%;
     cursor: pointer;
  }
  .quirks_left {
    position: absolute;
    top: 10%;
    left: 5%;
    width: 40%;
    text-align: center;
    img {
      width: 60%;
    }
  }
  .quirks_right {
    position: absolute;
    top: 30%;
    right: 7%;
    width: 50%;
    text-align: center;
    img {
      width: 100%;
    }
    .quirks_button {
      background-color: #2cb1e9;
      color: #fff;
      font-size: 30px;
      background-color: #2cb1e9;
      border: 1px solid #2cb1e9;
      border-radius: 5px;
      margin-top: 10%;
      padding: 10px 20px;
      font-weight: 700;
    }
  }
}
.index {
  background-image: url("https://holden-resource.oss-cn-shanghai.aliyuncs.com/holden/aboutUs/bg.jpg");
  background-attachment: fixed;
  background-size: cover;
}

.titleLine {
  background-color: #fff;
  font-weight: 700;
  .title {
    font-size: 40px;
  }
  .value {
    color: #86898d;
    font-size: 20px;
    padding: 0 200px;
  }
  img {
    width: 250px;
  }
  text-align: center;
  // margin: 1rem auto;
  padding: 80px 80px 40px;
}
.Experience {
  // background-color: rgba(255, 255, 255, 0.3);
  // color: #fff;
  padding: 100px 0 50px 0;
  .value {
    // color: #fff;
  }
}
.Clients {
  height: 400px;
  background-color: rgba(255, 255, 255, 0.7);
  text-align: center;
  padding-top: 80px;
  .text {
    .title {
      // padding: 100px 100px 0 100px;

      font-size: 35px;
      font-weight: 700;
      color: #003c50;
    }
    .value {
      color: rgb(110, 105, 105);
      font-size: 23px;
      text-align: center;
      vertical-align: center;
      padding: 50px;
      padding-bottom: 10px;
      font-weight: 700;
      .says {
        margin: 0 auto;
        width: 85%;
      }
    }
  }
}
.message {
  background-color: #fff;
  padding: 0 120px;
  text-align: center;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .box {
    cursor: pointer;
    background-color: #2cb1e9;
    width: 22%;
    height: 300px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    img {
      width: 100px;
      margin-bottom: 50px;
    }
    .value {
      font-size: 30px;
      color: #fff;
      font-weight: 700;
    }
  }
  .box:hover {
    background-color: #6cdf89;
  }
}
.things {
  background-color: #fff;
  padding: 0 120px;
  display: flex;
  text-align: center;
  // justify-content: space-around;
  .left,
  .right {
    font-size: 27px;
    font-weight: 700;
    color: #2cb1e9;
    width: 45%;
    margin: 2.5%;
    height: 200px;
    display: flex;
    flex-direction: column-reverse;
    justify-content: space-between;
  }
  .img {
    vertical-align: middle;
    // line-height: 200px;
    margin-top: 30px;
  }
  img {
    vertical-align: middle;

    // width: 27%;
    margin: 3%;
    margin-top: 20px;
    width: 250px;
  }
}
.doctors {
  background-color: #fff;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 0px 120px 80px 120px;
  .three {
    text-align: center;
    width: 23%;
    // border: 1px solid #d5dbe5;
    //   box-shadow: 4px 4px 4px 0 #d5dbe5;
    //   border-radius: 8px;

    padding: 15px;
    img {
      width: 100%;
      border-radius: 50%;
      margin-bottom: 20px;
    }
    .doctorName {
      font-size: 25px;
      font-weight: 700;
      color: #2cb1e9;
      padding: 5px 0;
    }
    .doctorValue {
      font-size: 18px;
    }
  }
}
.experience {
  background-color: #f4f4f4;
  padding: 0 120px 100px;
  .data {
    display: flex;
    text-align: center;
    padding: 70px 50px;
    .box {
      width: 20%;
      .num {
        font-size: 30px;
        font-weight: 700;
        color: #2cb1e9;
      }
      .detatil {
        color: #86898d;
        font-size: 14px;
      }
    }
  }
  img {
    height: 600px;
    width: 100%;
    margin: 0 auto;
  }
  // background-color: rgba(255, 255, 255, 0.3);
  // display: flex;
  // padding: 50px 120px;
  // justify-content: space-around;
  // .box {
  //   width: 23%;
  //   text-align: center;
  //   color: #fff;
  //   .num,
  //   .text {
  //     font-size: 23px;
  //     font-weight: 700;
  //   }
  // }
  // @media screen and (max-width: 576px) {
  //   .two {
  //     width: 80%;
  //     margin: 5% 10%;
  //   }
  //   .box {
  //     .num,
  //     .text {
  //       font-size: 40px;
  //     }
  //   }
  // }
}
.container {
}

.solutions {
  background-color: #fff;
  padding: 0 120px;
  i {
    color: #2cb1e9;
    font-size: 40px;
  }
  .title {
    font-size: 40px;
    font-weight: 700;
    color: #0cb4ec;
  }
  .solutionstext {
    font-size: 23px;
    margin-bottom: 10px;
  }
  .value {
    display: flex;
    justify-content: space-between;
    padding-top: 50px;
    .solutionsImg {
      // text-align: center;
      width: 35%;
      img {
        width: 100%;
      }
    }
    .solutionsValue {
      .text {
        span {
          font-weight: 700;
        }
        div {
        }
      }
      display: flex;
      flex-wrap: wrap;
      width: 65%;
      margin-left: 30px;
      .oneBox {
        width: 50%;
        padding-left: 20px;
        border-right: 1px solid #d5dbe5;
        border-bottom: 1px solid #d5dbe5;
      }
      .twoBox {
        width: 50%;
        padding-left: 20px;
        border-left: 1px solid #d5dbe5;
        border-bottom: 1px solid #d5dbe5;
      }
      .threeBox {
        width: 50%;
        padding-left: 20px;
        border-right: 1px solid #d5dbe5;
        border-top: 1px solid #d5dbe5;
      }
      .fourBox {
        width: 50%;
        padding-left: 20px;
        border-left: 1px solid #d5dbe5;
        border-top: 1px solid #d5dbe5;
      }
      .text {
        span {
          color: #108abe;
        }
        div {
          margin-top: 14px;
        }
      }
      font-size: 23px;
    }
  }
}

.products {
  background-color: #fff;
  .menu {
    display: flex;
    justify-content: center;
    border-bottom: 1px solid #bebebe;
    .icon {
      width: 150px;
      height: 120px;
      text-align: center;
      // line-height: 90px;
      // border: 1px solid #000;
      i {
        font-size: 40px;
        margin-top: 25px;
      }
    }
    .bg {
      color: #2cb1e9;
      //background-color: #2cb1e9;
    }
  }
  .productsValue {
    // background-image: url("~@/assets/img/holdenanswer.png");
    // background-size: cover;
    .holdenanswer {
      display: flex;
      // align-items: center;
      img {
        width: 500px;
        margin-left: 10px;
        margin-top: 50px;
      }
    }
    .apiimg {
      display: flex;
      // align-items: center;
      img {
        width: 400px;
        margin-left: 20px;
        margin-top: 40px;
      }
    }
    .api {
      margin-bottom: 20px;
      justify-content: space-between;
      .apileft {
        width: 35%;
      }
      .apiright {
        width: 65%;
      }
    }
    .two,
    .three,
    .four {
      padding: 30px 120px;
      .title {
        margin-bottom: 20px;
        font-size: 25px;
        font-weight: 700;
        text-align: center;
        color: #86898d;
        // text-shadow: 1px 1px #000;
      }
      .value {
        font-size: 18px;
      }
      .button {
        text-align: center;
        margin-top: 20px;

        .el-button {
          font-size: 20px;
          background-color: #2cb1e9;
          border: 1px solid #2cb1e9;
        }
      }
    }
  }
}
.SurveyPanda {
  display: flex;
  padding: 80px 120px 40px;
  .text {
    width: 45%;
    // color: #fff;
    padding: 50px;
    .title {
      font-weight: 700;
      font-size: 40px;
      color: #2cb1e9;
      text-shadow: 1px 1px #000;
    }
    .value {
      padding: 50px 0;
      font-size: 18px;
    }
  }
  .img {
    width: 55%;
    position: relative;
    img {
      width: 95%;
      position: absolute;
      right: 0;
      z-index: 2;
    }
    .color {
      width: 600px;
      height: 300px;
      background-color: #d0e3ea;
      position: absolute;
      left: -20px;
      top: 90px;
    }
  }
}
.news {
  background-color: #fff;
  padding: 0 120px;
  font-size: 18px;
  position: relative;
  .more {
    // width: 160px;
    padding: 0 20px;
    font-size: 16px;
    color: #409eff;
    background-color: #ecf5ff;
    border: 1px solid #409eff;
    border-radius: 8px;
    text-align: center;
    position: absolute;
    left: 120px;
    bottom: 30px;
  }
  .more:hover {
    cursor: pointer;
    color: #2cb1e9;
  }
  .newsList {
    // text-align: center;
    display: flex;
    justify-content: space-between;
    // flex-wrap: wrap;
    .topnews {
      width: 50%;
      height: 100%;
      .topNews {
        border: 1px solid #d5dbe5;
        border-radius: 8px;
        box-shadow: 4px 4px 4px 0 #d5dbe5;
        padding: 14px;
        cursor: pointer;

        img {
          width: 100%;
        }
        .title {
          // margin-top: 10px;
          font-weight: 700;
        }
        .label {
          margin: 15px 10px 0 0;
          font-size: 12px;
          display: inline-block;
          padding: 0.7px 7.5px 2px;
          background: #e8f2ff;
          border-radius: 4px;
          color: #2186c8;
        }
        .newsDesc {
          margin-top: 20px;
        }
      }
    }
    .notopnews {
      width: 47%;
    }
    .one {
      display: flex;
      cursor: pointer;
      padding: 14px;
      width: 100%;
      margin: 0px auto 20px;
      border: 1px solid #d5dbe5;
      border-radius: 8px;
      box-shadow: 4px 4px 4px 0 #d5dbe5;
      img {
        width: 300px;
        height: 170px;
      }
      .title {
        margin-left: 10px;
      }
      .label {
        margin-left: 10px;
        font-size: 12px;
        display: inline-block;
        padding: 0.7px 7.5px 2px;
        background: #e8f2ff;
        border-radius: 4px;
        color: #2186c8;
      }
    }
    .two {
      width: 40%;
    }
  }
}
.check {
  margin-right: 10px;
}
.from {
  // width: 60%;
  // margin: 80px auto;
  // padding: 30px;
  // transform: scale(1.3);
  padding-top: 0px;
  .formtitle {
    text-align: center;
    font-weight: 700;
    font-size: 25px;
    color: #ff0000;
  }
  @media screen and (max-width: 570px) {
    .formtitle {
      font-size: 45px;
    }
  }
  .el-form {
    // display: flex;
    // flex-wrap: wrap;
    // justify-content: space-between;
    padding: 10px;
    /deep/ .el-form-item {
      display: inline-block;
      display: flex;
      // flex-wrap: wrap;
      justify-content: start;
      &:nth-child() {
        .el-form-item__label {
          // margin-left: 7px;
        }
      }
      &:not(.text) {
        // width: 50%;
      }
      &.text {
        width: 100%;
      }
      .el-form-item__content {
        font-size: 11px;
        line-height: 20px;
        flex: 1;
        .el-input {
          width: 238px !important;
        }
      }

      .el-form-item__label {
        width: 125px;
        font-size: 15px;
        display: block;
        font-weight: normal;
      }
      .el-textarea__inner {
        min-height: 104px !important;
      }
      .el-input__inner,
      .el-textarea__inner {
        background: #fafafa;
        border: 1px solid #e6e6e6;
        border-radius: 7px;
        font-size: 15px;
        width: 390px;
      }
      @media screen and (max-width: 576px) {
        .el-input__inner {
          font-size: 35px;
          width: 700px;
          height: 80px;
        }
        .el-form-item__label {
          font-size: 35px;
          width: 250px;
        }
        .el-form-item__content {
          font-size: 30px;
          line-height: 40px;
        }
      }
      .el-form-item__error {
        font-size: 12px !important;
      }
    }
  }
  & > * {
    margin: 20px;
  }
  div {
    margin-top: 12px;
  }
  .button {
    margin: 0 auto;
    margin-top: 20px;
    background: #217df6;
    font-size: 13px;
    color: #fff;
    border-radius: 7px;
    text-align: center;
    width: 150px;
    padding: 10px;
    // height: 34px;
    // line-height: 34px;
    cursor: pointer;
  }
  @media screen and (max-width: 576px) {
    .button {
      font-size: 35px;
    }
  }
}
@media screen and (max-width: 576px) {
  .quotevalue {
    font-size: 80px;
  }
  .top {
    /deep/.el-carousel {
      height: 1800px;

      .el-carousel__container {
        height: 1800px;
      }
    }
  }

  .banner {
    .value {
      width: 85%;
      font-size: 140px;
      button {
        font-size: 80px;
        margin: 0 auto;
        margin-top: 150px;
        padding: 30px;
        background-color: #2cb1e9;
        color: #fff;
        border: none;
      }
    }
    .readmore {
      top: 70%;
    }

    .imgBg {
      img {
        height: 1800px;
        width: auto;
        position: absolute;
        top: 0;
        right: 0;
      }
    }
    .eada_imgBg {
      img {
        right: -1400px;
      }
    }
    .value_appa {
      width: 100%;
      top: 20%;
    }
    .appa_logo {
      width: 500px;
      height: 500px;

      img {
        width: 400px;
        height: auto;
        margin-top: 200px;
      }
    }
    .value_eada {
      width: 100%;
      padding-top: 300px;
      padding-left: 130px;
      .eada_logo {
        img {
          width: 800px;
        }
      }
      .banner_button {
        font-size: 70px;
        padding: 10px 30px;
      }
    }
    .value_intell{
      background-color: rgba(255, 255, 255, 0.5);
      font-size: 85px;
      width: 800px;
      padding: 50px;
      left: 5%;
      top: 65%;
    }
    .quirks_left {
      width: 80%;
      left: 10%;
      top: 5%;
    }
    .quirks_right {
      top: 65%;
      right: 5%;
      width: 88%;
      .quirks_button {
        font-size: 75px;
        margin-top: 5%;
      }
    }
  }
  .Clients {
    height: 900px;
    .text {
      .title {
        font-size: 70px;
      }
      .value {
        font-size: 55px;
      }
    }
    /deep/.el-carousel {
      height: 600px;

      .el-carousel__container {
        height: 600px;
      }
    }
  }
  .titleLine {
    padding: 120px;
    .title {
      font-size: 80px;
    }
    img {
      width: 500px;
    }
    .value {
      font-size: 40px;
    }
  }
  .message {
    .box {
      width: 100%;
      margin-bottom: 150px;
      height: 900px;
      img {
        width: 400px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .solutions {
    .solutionstext {
      font-size: 70px;
    }
    .annotation {
      font-size: 23px;
    }
    .title {
      font-size: 60px;
    }
    .value {
      display: block;
      .solutionsValue {
        width: 100%;
        .solutionbox {
          padding: 20px;
          // width: 100%;
        }

        .text {
          span {
            font-size: 70px;
          }
          div {
            font-size: 70px;
          }
        }
      }
    }
  }
  i {
    font-size: 100px;
  }
  .things {
    .left,
    .right {
      font-size: 65px;
      height: 500px;
    }
    .title {
      font-size: 60px;
    }
    .value {
      font-size: 40px;
      .d-block {
        display: inline-block !important;
      }
      .left,
      .right {
        width: 100%;
        div {
          margin-top: 40px;
        }
      }
    }
  }
  .experience {
    padding: 0 50px 100px;
    .data {
      padding: 50px 0;
      .box {
        .num {
          font-size: 50px;
        }
        .detatil {
          font-size: 25px;
        }
      }
    }
  }
  .products {
    .menu {
      .icon {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: center;
        width: 350px;
        height: 230px;
        font-size: 40px;
        i {
          font-size: 80px;
          width: 100%;
        }
      }
    }
    .productsValue {
      .holdenanswer {
        flex-wrap: wrap;
        img {
          width: 100%;
          margin-bottom: 30px;
        }
      }
      .apiimg {
        flex-wrap: wrap;
        img {
          width: 100%;
        }
      }
      .api {
        flex-wrap: wrap;
        .apileft {
          width: 100%;
        }
        .apiright {
          width: 100%;
        }
      }
      .two,
      .three,
      .four {
        .title {
          font-size: 80px;
        }
        .value {
          font-size: 70px;
        }
        .button {
          .el-button {
            font-size: 70px;
            padding: 30px;
          }
        }
      }
    }
  }
  .SurveyPanda {
    display: block;
    position: relative;
    padding-top: 600px;
    .img {
      position: absolute;
      top: 100px;
      width: 80%;
    }
    .text {
      width: 90%;
      .title {
        font-size: 80px;
      }
      .value {
        font-size: 70px;
      }
    }
  }
  .doctors {
    .three {
      width: 47%;
      padding: 20px;
      margin-bottom: 50px;
      .doctorName {
        font-size: 50px;
      }
      .doctorValue {
        font-size: 40px;
      }
    }
  }
  .news {
    padding-bottom: 100px;
    .more {
      font-size: 40px;
      bottom: 10px;
    }
    .newsList {
      display: block;
      .topnews {
        width: 100%;
        .topNews {
          .title {
            font-size: 70px;
          }
          .label {
            font-size: 50px;
            margin-bottom: 10px;
          }
          .newsDesc {
            font-size: 60px;
          }
        }
      }
      .notopnews {
        width: 100%;
      }
      .one {
        flex-wrap: wrap;
        img {
          width: 100%;
          height: 800px;
        }
        .label {
          font-size: 50px;
          margin-bottom: 10px;
        }
        .title {
          font-size: 70px;
        }
      }
    }
  }
  /deep/ .el-dialog__wrapper {
    .el-dialog {
      width: 100% !important;
      .el-dialog__footer {
        .el-button {
          font-size: 70px;
          padding: 20px;
        }
      }
    }
  }
}
</style>
